/**
 * Use this class for Feature toggling
 */

export class FeatureManager {
  static isOnboardingEnabled = false
  static useNotificationMock = false
  static isChangeNameLaterEnabled = false
  static useSnackBarUndo = false
}
